import { useEffect, useRef, useState } from "react";

import { structuredLogger } from "@/lib/logging";

// A failed or timed-out attempt stays closed even if its requests later resolve.
// Retry reloads the page, restarting all authoritative checks together.
export const AUTH_GATE_TIMEOUT_MS = 15_000;

export function useAuthGateRecovery(pending: boolean, failed = false, stage: "auth" | "role" | "age" | "session" = "auth") {
  const currentStage = useRef(stage);
  currentStage.current = stage;
  const [blocked, setBlocked] = useState(false);
  useEffect(() => {
    if (failed) { setBlocked(true); return; }
    if (!pending || blocked) return;
    const timer = window.setTimeout(() => {
      structuredLogger.warn("Access check timed out", { stage: currentStage.current });
      setBlocked(true);
    }, AUTH_GATE_TIMEOUT_MS);
    return () => window.clearTimeout(timer);
  }, [pending, failed, blocked]);
  return failed || blocked;
}
